//
// locales/vanilla/co.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/mastodon/locales/co.json';
import localeData from 'react-intl/locale-data/en.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
